import { render, staticRenderFns } from "./GateConfig.vue?vue&type=template&id=7ec473c2&"
import script from "./GateConfig.vue?vue&type=script&lang=js&"
export * from "./GateConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports